import { InsightCatalogue } from '../InsightCatalogue';
import {
  AggregateOnlyInsightPayload,
  BaseInsightPayload,
  InsightMetric,
  validateInsightStructure,
} from '../InsightDataPayload';

export interface ProjectsCompletedPayload extends AggregateOnlyInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_PROJECTS_COMPLETED;
    id: string;
    attributes: {
      aggregate: {
        projects_completed: InsightMetric;
      };
    };
  };
}

export const parseProjectsCompletedPayload = (
  payload: BaseInsightPayload
): ProjectsCompletedPayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_PROJECTS_COMPLETED,
    data.attributes,
    false,
    true,
    ['projects_completed']
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    aggregate: { projects_completed: InsightMetric };
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_PROJECTS_COMPLETED,
      id: data.id,
      attributes: {
        aggregate: {
          projects_completed: typedAttributes.aggregate.projects_completed,
        },
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
